import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

type CheckmarkIconProps = IconProps & {
  strokeWidth?: number
}

export const CheckmarkIcon: FC<React.PropsWithChildren<CheckmarkIconProps>> = ({
  color = theme.palette.success.main,
  size = IconSize.small,
  strokeWidth = 2,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0541 4.33203L6.10767 11.6654L2.9502 8.33203"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  </>
)
